import React, { useState } from 'react';
import { CgMenuHotdog } from 'react-icons/cg';
import MobileNavbar from './MobileNavbar';
import DesktopNavbar from './DesktopNavbar';
import logo from '../images/logo.svg';
import logobg from '../images/logobg.svg';

const Navbar = ({ openbar, setOpenBar }) => {
	const [navbarChange, setNavbarChange] = useState(false);

	const changeBackground = () => {
		if (window.scrollY >= 300) {
			setNavbarChange(true);
		} else {
			setNavbarChange(false);
		}
		// console.log(window.scrollY);
	};

	window.addEventListener('scroll', changeBackground);

	return (
		<div>
			<nav className={navbarChange ? 'navbar changeBgColor' : 'navbar'}>
				<div className='flex items-center justify-between mx-4'>
					<div>
						<CgMenuHotdog
							onClick={() => setOpenBar(!openbar)}
							className='burger-menu cursor-pointer w-12 h-12 flex text-blue-100 lg:hidden'
						/>
					</div>
					{navbarChange ? (
						<img src={logobg} alt='logobg' className='logo logorotate' />
					) : (
						<img src={logo} alt='logo' className='logo logorotate' />
					)}
				</div>
				<DesktopNavbar />
				{openbar && <MobileNavbar />}
			</nav>
		</div>
	);
};

export default Navbar;
